import * as SliderPrimitive from '@radix-ui/react-slider'
import * as React from 'react'

import { cn } from '../utils'

type Props = {
  trackClassName?: string
  /** Number of thumbs to render. Defaults to the length of the value array, or 1 if not provided. */
  thumbCount?: number
} & React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, Props>(
  ({ className, thumbCount, ...props }, ref) => {
    // Determine how many thumbs to render based on value array length or explicit thumbCount
    const count = thumbCount ?? (Array.isArray(props.value) ? props.value.length : 1)

    return (
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          'relative flex w-full touch-none select-none items-center',
          className,
        )}
        {...props}
      >
        <SliderPrimitive.Track
          className={cn(
            'bg-secondary relative h-2 w-full grow overflow-hidden rounded-full',
            props.trackClassName,
          )}
        >
          <SliderPrimitive.Range className="bg-input-focus-border absolute h-full" />
        </SliderPrimitive.Track>
        {Array.from({ length: count }).map((_, index) => (
          <SliderPrimitive.Thumb
            key={index}
            className="border-input-focus-border bg-background ring-offset-background focus-visible:ring-ring focus-visible:outline-hidden block h-5 w-5 rounded-full border-2 transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          />
        ))}
      </SliderPrimitive.Root>
    )
  },
)
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
